module.exports = __webpack_public_path__ + "static/media/arrow_drop_down_white_24dp.db659e5f.svg";